(function() {
    'use strict';
    angular.module('wbDashboard')
    .constant('Constant', {
        logoutModalDelayTimeout: 2 * 60 + 1,
        logoutModalTimeout: 5 * 60,
        logoutModalTimeoutDev: 28 * 60,
        themeDir: "app/themes/aurea/templates/",
        componentDir: "app/themes/aurea/segments/",
        themeHome: "/overview"
    });
})();
